import { Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const MissingConfigMessage = styled(Typography.Text)`
  && {
    font-family: 'Noto Sans', sans-serif;
    color: ${COLOR_OPTIONS.NEUTRAL_100};
    letter-spacing: -0.105px;
  }
`;

export const MissingConfigContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
`;

export const MissingConfigIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${COLOR_OPTIONS.WHITE};
  border: 1px solid ${COLOR_OPTIONS.GRAY_5};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 24px;
    height: 24px;

    path {
      fill: ${COLOR_OPTIONS.RED_60};
    }
  }
`;
